/**
 * Métadonnées d'affichage des types de résultats de la recherche globale.
 *
 * Une icône par type : la palette respecte la règle projet « icône + mot »
 * (jamais la couleur seule — soleil de cuverie + daltonisme). Les LIBELLÉS de
 * type vivent déjà dans les contrats (`RECHERCHE_TYPE_LABELS`), on ne les
 * redéfinit pas ici (DRY).
 */

import type { RechercheType } from "@champ-erp/contracts";
import {
  Container,
  FileText,
  Grape,
  HelpCircle,
  type LucideIcon,
  MapPin,
  Package,
  Paperclip,
  ShoppingBag,
  User,
  Users,
} from "lucide-react";

/** Icône associée à chaque type de résultat (10 types du référentiel contrats). */
export const RECHERCHE_TYPE_ICONS: Record<RechercheType, LucideIcon> = {
  cuvee: Grape,
  lot: Package,
  client: Users,
  document: FileText,
  parcelle: MapPin,
  membre: User,
  produit: ShoppingBag,
  cuve: Container,
  piece_jointe: Paperclip,
  aide: HelpCircle,
};
